import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Users from './pages/Users';
import MyOrders from './pages/MyOrders';
import ApproveOrders from './pages/ApproveOrders';
import FinalOrders from './pages/FinalOrders';
import OrderSettings from './pages/OrderSettings';
import ManageProducts from './pages/ManageProducts';
import DuplicateOrderSettings from './pages/DuplicateOrderSettings';
import OrderReports from './pages/OrderReports';
import Settings from './pages/Settings';
import RequestProduct from './components/RequestProduct';
import ManageProductRequests from './components/ManageProductRequests';
import OrderConsolidation from './pages/OrderConsolidation';
import DialogTest from './pages/DialogTest';
import { authService } from './services/api';
import { DialogProvider } from './components/DialogContext';
import './App.css';

function App() {
  const isAuthenticated = authService.isAuthenticated();

  return (
    <DialogProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Route */}
            <Route
              path="/login"
              element={
                isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
              }
            />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Navbar />
                <Dashboard />
                <Footer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Navbar />
                <Products />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Request Product - Staff */}
          <Route
            path="/request-product"
            element={
              <ProtectedRoute allowedRoles={['staff']}>
                <Navbar />
                <RequestProduct />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Manage Product Requests - Super Admin */}
          <Route
            path="/manage-product-requests"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'super_super_admin']}>
                <Navbar />
                <ManageProductRequests />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Manage Products - Super Admin Only */}
          <Route
            path="/manage-products"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'super_super_admin']}>
                <Navbar />
                <ManageProducts />
                <Footer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['super_super_admin', 'super_admin']}>
                <Navbar />
                <Users />
                <Footer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-orders"
            element={
              <ProtectedRoute allowedRoles={['staff']}>
                <Navbar />
                <MyOrders />
                <Footer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/approve-orders"
            element={
              <ProtectedRoute allowedRoles={['senior_nurse']}>
                <Navbar />
                <ApproveOrders />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Final Orders - Super Admin Only */}
          <Route
            path="/final-orders"
            element={
              <ProtectedRoute allowedRoles={['super_super_admin', 'super_admin']}>
                <Navbar />
                <FinalOrders />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Order Consolidation - Senior Nurse, Super Admin, Super Super Admin */}
          <Route
            path="/order-consolidation"
            element={
              <ProtectedRoute allowedRoles={['senior_nurse', 'super_admin', 'super_super_admin']}>
                <Navbar />
                <OrderConsolidation />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Settings - Super Admin */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'super_super_admin']}>
                <Navbar />
                <Settings />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Order Settings - Super Super Admin Only */}
          <Route
            path="/order-settings"
            element={
              <ProtectedRoute allowedRoles={['super_super_admin']}>
                <Navbar />
                <OrderSettings />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Duplicate Order Settings - Super Super Admin Only */}
          <Route
            path="/duplicate-settings"
            element={
              <ProtectedRoute allowedRoles={['super_super_admin']}>
                <Navbar />
                <DuplicateOrderSettings />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Order Reports - Senior Nurse, Super Admin, Super Super Admin */}
          <Route
            path="/order-reports"
            element={
              <ProtectedRoute allowedRoles={['senior_nurse', 'super_admin', 'super_super_admin']}>
                <Navbar />
                <OrderReports />
                <Footer />
              </ProtectedRoute>
            }
          />

          {/* Dialog Test Page - All Authenticated Users */}
          <Route
            path="/dialog-test"
            element={
              <ProtectedRoute>
                <DialogTest />
              </ProtectedRoute>
            }
          />

          {/* Root redirect */}
          <Route
            path="/"
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
            }
          />

          {/* 404 - Not Found */}
          <Route
            path="*"
            element={
              <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <div style={{
                  textAlign: 'center',
                  background: 'white',
                  padding: '60px 40px',
                  borderRadius: '16px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                }}>
                  <div style={{ fontSize: '72px', marginBottom: '20px' }}>🔍</div>
                  <h1 style={{ fontSize: '32px', color: '#333', marginBottom: '10px' }}>404</h1>
                  <p style={{ color: '#666', marginBottom: '30px' }}>Page not found</p>
                  <button
                    onClick={() => window.location.href = '/dashboard'}
                    style={{
                      padding: '12px 24px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer'
                    }}
                  >
                    Go to Dashboard
                  </button>
                </div>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
    </DialogProvider>
  );
}

export default App;
